(function(){
  var root = document.getElementById('lem-top');
  if(!root) return;
  var variants = [];
  try{ variants = JSON.parse(document.getElementById('lem-variants').textContent); }catch(e){}
  var state = { renk: null, paket: null, qty: 1 };
  var sel = variants.find(function(v){return v.available;}) || variants[0];
  if(sel){ state.renk = sel.renk; state.paket = sel.paket; }

  function fmt(cents){ return '₺' + (cents/100).toLocaleString('tr-TR'); }
  function currentVariant(){
    return variants.find(function(v){ return v.renk===state.renk && v.paket===state.paket; });
  }
  function update(){
    var v = currentVariant();
    if(!v) return;
    var priceEl = root.querySelector('.lem-price');
    var oldEl = root.querySelector('.lem-old');
    var saveEl = root.querySelector('.lem-save');
    if(priceEl) priceEl.textContent = fmt(v.price);
    if(oldEl) oldEl.textContent = v.compare>v.price ? fmt(v.compare) : '';
    if(saveEl){ var s=v.compare-v.price; saveEl.textContent = s>0 ? fmt(s)+' Tasarruf':''; saveEl.style.display = s>0?'':'none'; }
    var selRenk = root.querySelector('.lem-sel-renk'); if(selRenk) selRenk.textContent = state.renk;
    var atc = root.querySelector('.lem-atc'); if(atc){ atc.dataset.productId = v.id; }
    syncStandardHooks(v);
    document.dispatchEvent(new CustomEvent('lem:variant', {detail:{renk:state.renk, paket:state.paket, price:v.price, compare:v.compare, id:v.id}}));
  }
  // Expose selected variant to 3rd-party apps (kapıda ödeme / COD, upsell, etc.)
  function syncStandardHooks(v){
    // hidden id inputs in any cart form
    document.querySelectorAll('.lem-var-id, form[action*="/cart"] input[name="id"], form[action*="/cart/add"] input[name="id"]').forEach(function(inp){
      if(inp.value != v.id){ inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles:true})); }
    });
    // URL ?variant= param — most COD apps read this
    try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch(e){}
    // Shopify analytics meta
    try { if(window.ShopifyAnalytics && window.ShopifyAnalytics.meta){ window.ShopifyAnalytics.meta.selectedVariantId = v.id; } } catch(e){}
    // Shopify standard variant change event
    try { document.dispatchEvent(new CustomEvent('variant:change', {detail:{variant:{id:v.id, price:v.price}}})); } catch(e){}
    syncQty();
  }
  function syncQty(){
    document.querySelectorAll('.lem-var-qty, form[action*="/cart"] input[name="quantity"]').forEach(function(q){ q.value = state.qty; q.dispatchEvent(new Event('change', {bubbles:true})); });
  }
  root.querySelectorAll('.lem-swatch').forEach(function(b){
    b.addEventListener('click', function(){
      state.renk = b.dataset.renk;
      root.querySelectorAll('.lem-swatch').forEach(function(x){
        var on = x===b;
        x.setAttribute('aria-pressed', on);
        var dot = x.querySelector('.lem-swatch-dot');
        dot.style.border = (on?'2.5px':'1.5px')+' solid '+(on?'var(--lem-green)':'var(--lem-line-3)');
        var lbl = x.querySelector('span:last-child');
        lbl.style.fontWeight = on?'700':'500'; lbl.style.color = on?'var(--lem-ink)':'var(--lem-ink-muted)';
      });
      update();
    });
  });
  root.querySelectorAll('.lem-bundle').forEach(function(b){
    b.addEventListener('click', function(){
      state.paket = b.dataset.paket;
      root.querySelectorAll('.lem-bundle').forEach(function(x){
        var on = x===b;
        x.setAttribute('aria-pressed', on);
        x.style.background = on?'var(--lem-green-soft-2)':'#fff';
        x.style.border = (on?'2px':'1.5px')+' solid '+(on?'var(--lem-green)':'var(--lem-line-3)');
        var radio = x.querySelector('.lem-bundle-radio'); radio.style.borderColor = on?'var(--lem-green)':'var(--lem-line-3)';
        radio.querySelector('span').style.display = on?'':'none';
      });
      update();
    });
  });
  var qEl = root.querySelector('.lem-qty');
  var dec = root.querySelector('.lem-qty-dec'); if(dec) dec.addEventListener('click', function(){ if(state.qty>1){state.qty--; qEl.textContent=state.qty; syncQty();} });
  var inc = root.querySelector('.lem-qty-inc'); if(inc) inc.addEventListener('click', function(){ state.qty++; qEl.textContent=state.qty; syncQty();} );

  var track = root.querySelector('.lem-galtrack');
  if(track){
    var slides = track.querySelectorAll('.lem-gal-slide');
    var dotsWrap = root.querySelector('.lem-dots');
    slides.forEach(function(s,i){
      var d = document.createElement('button'); d.type='button'; d.setAttribute('aria-label','Gorsel '+(i+1));
      d.style.cssText='width:'+(i===0?'22px':'8px')+';height:8px;border-radius:8px;border:none;background:'+(i===0?'var(--lem-green)':'#D9CDBD')+';transition:all .2s';
      d.addEventListener('click',function(){ track.scrollTo({left:track.clientWidth*i, behavior:'smooth'}); });
      dotsWrap.appendChild(d);
    });
    function syncDots(){
      var idx = Math.round(track.scrollLeft/track.clientWidth);
      dotsWrap.querySelectorAll('button').forEach(function(d,i){ d.style.width=i===idx?'22px':'8px'; d.style.background=i===idx?'var(--lem-green)':'#D9CDBD'; });
      root.querySelectorAll('.lem-thumb').forEach(function(t,i){ t.classList.toggle('is-active', i===idx); });
    }
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(syncDots); });
    root.querySelectorAll('.lem-thumb').forEach(function(t){ t.addEventListener('click',function(){ track.scrollTo({left:track.clientWidth*parseInt(t.dataset.goto), behavior:'smooth'}); }); });
  }

  function addToCart(btn){
    var id = btn.dataset.productId; if(!id) return;
    btn.disabled = true; var orig = btn.textContent; btn.textContent = 'Ekleniyor...';
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id: parseInt(id,10), quantity: state.qty}]})})
      .then(function(r){ if(!r.ok){ return r.text().then(function(t){ throw new Error(t); }); } return r.json(); })
      .then(function(){
        btn.textContent = '✓ Sepete Eklendi';
        window.location.href = '/cart';
      })
      .catch(function(){ btn.textContent = 'Tekrar deneyin'; btn.disabled = false; setTimeout(function(){btn.textContent=orig;},1800); });
  }
  var atcBtn = root.querySelector('.lem-atc');
  if(atcBtn) atcBtn.addEventListener('click', function(){ addToCart(this); });
  update();
})();
